export default __webpack_public_path__ + "volume-up-interface-symbol.png";